"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFrameworkMessage = void 0;
var React = require("react");
var FrameworkMessagesPopup_1 = require("./FrameworkMessagesPopup");
var useFrameworkMessage = function () {
    var _a = React.useState(false), popupVisible = _a[0], setPopupVisible = _a[1];
    var _b = React.useState(), messages = _b[0], setMessages = _b[1];
    var ResolveComplete = React.useRef();
    var handleOnClose = function () {
        setPopupVisible(false);
        ResolveComplete.current();
    };
    var handleOnComplete = function (responses) {
        setPopupVisible(false);
        ResolveComplete.current(responses);
    };
    var showFrameworkMessage = function (msg) {
        return new Promise(function (resolve) {
            setMessages(msg);
            ResolveComplete.current = resolve;
            setPopupVisible(true);
        });
    };
    var FrameworkMessagePopup = function (staticProps) {
        return popupVisible ? (React.createElement(FrameworkMessagesPopup_1.default, __assign({}, staticProps, { Messages: messages, OnCloseRequest: handleOnClose, OnComplete: handleOnComplete }))) : (React.createElement(React.Fragment, null));
    };
    return { FrameworkMessagePopup: FrameworkMessagePopup, showFrameworkMessage: showFrameworkMessage };
};
exports.useFrameworkMessage = useFrameworkMessage;
